/*
 *
 * TopMenu
 *
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Wrapper,
  Content,
} from './styledComponents';

const TopMenu = ({ links, children, searchOnChange, searchValue }) => {
  // Was read off React internals (`children._owner.pendingProps.location`),
  // which only worked because react-router v5 passed `location` as a prop to
  // the routed child. v7 passes nothing, so read the router directly.
  const { pathname } = useLocation();
  const terms = pathname === '/terms';
  return(<Wrapper>
    <Content divPadding={terms ? 200 : 0} >
      {children}
    </Content>
  </Wrapper>
)};

export default TopMenu;
